import * as React from "react"

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 192" {...props}>
      <path
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={8.52}
        stroke="#333"
        d="M154.85 96h-118"
      />
    </svg>
  )
}

export default SvgComponent
